'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--FlowBranch';

var EntypoFlowBranch = function EntypoFlowBranch(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M16.4,4c0-1.326-1.074-2.4-2.4-2.4S11.6,2.674,11.6,4c0,0.961,0.568,1.784,1.384,2.167c-0.082,1.584-1.27,2.122-3.335,2.896C8.779,9.39,7.82,9.752,7,10.297V6.176C7.825,5.796,8.4,4.967,8.4,4c0-1.326-1.074-2.4-2.4-2.4S3.6,2.674,3.6,4c0,0.967,0.576,1.796,1.4,2.176v7.649C4.175,14.204,3.6,15.033,3.6,16c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4c0-0.961-0.568-1.784-1.384-2.167c0.082-1.583,1.271-2.122,3.335-2.896c2.03-0.762,4.541-1.711,4.64-4.756C15.82,5.803,16.4,4.971,16.4,4z M6,2.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C5.235,5.385,4.616,4.764,4.616,4C4.616,3.234,5.235,2.615,6,2.615z M6,17.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C7.384,16.764,6.764,17.385,6,17.385z M14,5.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C15.384,4.764,14.764,5.385,14,5.385z' })
    );
};

exports.default = EntypoFlowBranch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/FlowBranch.js
// module id = ./node_modules/react-entypo/lib/entypo/FlowBranch.js
// module chunks = 2